import { catchError, map, of, tap } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { RoomDTO } from '../../../../dto/location/room.dto';
import { Room } from '../../../../models/location/Room.model';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { environment } from '../../../../environment/environment';
import { DUNA_LOCATIONS_ADMIN_EVENT } from './locations-admin-events';

export function rooms_admin(componentDataSourceService: ComponentDataSourceService) {
  return {
    name: 'Lokaler (admin)',
    description: 'Alle lokaler med redigering',
    execute: (params?: LoadDataParams) => {
      return componentDataSourceService.http
        .get<any>(`${environment.apiUrl}/locations/rooms`, params?.queryParams ? { params: params.queryParams } : {})
        .pipe(
          catchError((error) => {
            console.error('Error fetching rooms:', error);
            return of({ items: [], totalCount: 0 });
          }),
          map((result) => {
            if (result && result.items) {
              const rooms = result.items.map((room: any) => {
                const roomDTO: RoomDTO = {
                  guid: room.guid,
                  room_name: room.room_name,
                  location_guid: room.location_guid,
                  capacity: room.capacity,
                  description: room.description,
                  locations_name: room.locations_name
                };
                return Room.fromDTO(roomDTO);
              });
              return {
                items: rooms,
                totalCount: result.totalCount,
                pageSize: result.pageSize,
                pageIndex: result.pageIndex
              };
            }
            return { items: [], totalCount: 0 };
          })
        );
    },
    settings: {
      columns: [
        { key: 'room_name', header: 'Lokale', type: 'text', sortable: true },
        { key: 'locations_name', header: 'Lokation', type: 'text', sortable: true },
        { key: 'capacity', header: 'Kapacitet', type: 'number', sortable: true },
        { key: 'description', header: 'Beskrivelse', type: 'text' },
        {
          key: 'edit',
          header: '',
          type: 'button',
          buttonText: 'Rediger',
          buttonColor: 'primary',
          variant: 'stroked',
          action: (item: Room) => {
            window.dispatchEvent(
              new CustomEvent(DUNA_LOCATIONS_ADMIN_EVENT, {
                detail: { entity: 'room', action: 'open-edit', row: item }
              })
            );
          }
        },
        {
          key: 'delete',
          header: '',
          type: 'button',
          buttonText: 'Slet',
          buttonColor: 'warn',
          variant: 'stroked',
          action: (item: Room) => {
            window.dispatchEvent(
              new CustomEvent(DUNA_LOCATIONS_ADMIN_EVENT, {
                detail: { entity: 'room', action: 'confirm-delete', row: item }
              })
            );
          }
        }
      ],
      pageable: true,
      sortable: true,
      rowHover: true,
      searchable: true,
      defaultSortColumn: 'room_name',
      defaultSortDirection: 'asc'
    }
  };
}
